import React, {useState} from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {i18n2} from 'features/i18n/i18n';
import {
  TextField,
  Paper,
  Box,
  FormControlLabel,
  Checkbox,
  Divider,
} from '@material-ui/core';

const MultipleSelectAll = ({
  options,
  changeValue,
  label,
  customOptionLabel,
  customOptionSelected,
}) => {
  const [columns, setColumns] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleToggleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) {
        setColumns([...(options.data ? options.data : options)]);
        changeValue([...(options.data ? options.data : options)]);
      } else {
        setColumns([]);
        changeValue([]);
      }
      return !prev;
    });
  };

  const handleChange = (_e, value, reason) => {
    if (reason === 'clear' || reason === 'removeOption') setSelectAll(false);
    if (reason === 'selectOption' && value.length === options.length)
      setSelectAll(true);
    setColumns(value);

    value !== null ? changeValue(value) : changeValue('');
  };
  return (
    <Autocomplete
      multiple
      id="tags-standard"
      disableCloseOnSelect
      filterSelectedOptions
      freeSolo={false}
      limitTags={4}
      options={options.data ? options.data : options}
      value={columns}
      getOptionLabel={
        customOptionLabel
          ? customOptionLabel
          : (option) =>
              typeof option === 'object' ? `${option.title}` : option
      }
      getOptionSelected={
        customOptionSelected
          ? customOptionSelected
          : (option, value) => {
              return typeof option === 'object'
                ? option.id === value.id
                : option === value;
            }
      }
      onChange={(_e, value, reason) => handleChange(_e, value, reason)}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={label} />
      )}
      PaperComponent={(paperProps) => {
        const {children, ...restPaperProps} = paperProps;
        return (
          <Paper {...restPaperProps}>
            <Box
              onMouseDown={(e) => e.preventDefault()} // prevent blur
              pl={1.5}
              py={0.5}
            >
              <FormControlLabel
                onClick={(e) => {
                  e.preventDefault(); // prevent blur
                  handleToggleSelectAll();
                }}
                label={i18n2._('Seleccionar todos')}
                control={
                  <Checkbox id="select-all-checkbox" checked={selectAll} />
                }
              />
            </Box>
            <Divider />
            {children}
          </Paper>
        );
      }}
    />
  );
};

export default MultipleSelectAll;
